import { createSlice } from "@reduxjs/toolkit";
import { makeThunk } from "helpers/makeThunk";
import { handleCommonCases } from "helpers/thunkHandler";
import { SEND_SMS_MESSAGE } from "helpers/url_helper";

export const sendSmsMessage = makeThunk({ url: SEND_SMS_MESSAGE });

const initialState = {
  isLoading: false,
};

const sendSmsSlice = createSlice({
  name: "sendSms",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    handleCommonCases(builder, sendSmsMessage, {
      loadingKey: "isLoading",
    });
  },
});

export default sendSmsSlice.reducer;
